import React from "react";
import EditIconSvg from "assets/edit-icon.svg";
import ExternalIconSvg from "assets/external-icon.svg";
import CheckedIcon from "assets/checked.svg";
import UncheckedIcon from "assets/unchecked.svg";
import {
  TableContainer,
  Table,
  THead,
  TH,
  TD,
  StatusBadge,
  ActionsContainer,
  ActionButton,
  ActionIcon,
  EmptyState,
} from "./styles";

function FormsTable({ data, onEdit, onDuplicate, onToggleStatus }) {
  return (
    <TableContainer>
      <Table>
        <THead>
          <tr>
            <TH>Nome</TH>
            <TH>Slug</TH>
            <TH>Versão</TH>
            <TH>Situação</TH>
            <TH>Ações</TH>
          </tr>
        </THead>
        <tbody>
          {data.length > 0 ? (
            data.map((item) => (
              <tr key={item.slug}>
                <TD>{item.name}</TD>
                <TD>{item.slug}</TD>
                <TD>{item.version}</TD>
                <TD>
                  <StatusBadge active={item.isCurrent}>
                    {item.isCurrent ? "Ativo" : "Inativo"}
                  </StatusBadge>
                </TD>
                <TD>
                  <ActionsContainer>
                    <ActionButton title="Editar" onClick={() => onEdit(item)}>
                      <ActionIcon src={EditIconSvg} alt="Editar" />
                    </ActionButton>
                    <ActionButton title="Duplicar" onClick={() => onDuplicate(item)}>
                      <ActionIcon src={ExternalIconSvg} alt="Duplicar" />
                    </ActionButton>
                    <ActionButton
                      title={item.isCurrent ? "Desativar" : "Ativar"}
                      onClick={() => onToggleStatus(item)}
                    >
                      <ActionIcon
                        src={item.isCurrent ? CheckedIcon : UncheckedIcon}
                        alt="Atualizar situação"
                      />
                    </ActionButton>
                  </ActionsContainer>
                </TD>
              </tr>
            ))
          ) : (
            <tr>
              <TD colSpan={5}>
                <EmptyState>Nenhum formulário encontrado.</EmptyState>
              </TD>
            </tr>
          )}
        </tbody>
      </Table>
    </TableContainer>
  );
}

export default FormsTable;
